import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'

const ScoreDetailsTab = ({ data, traits }) => {
  const [currentTab, setCurrentTab] = useState(0)
  const testScore = data[currentTab]

  const traitDetails = [
    {
      dominant: 'freedom',
      recessive: 'structured',
      trait: traits.freedom,
    },
    {
      dominant: 'adventurous',
      recessive: 'laidback',
      trait: traits.adventurous,
    },
    {
      dominant: 'teamwork',
      recessive: 'independent',
      trait: traits.teamwork,
    },
    {
      dominant: 'systematic',
      recessive: 'agile',
      trait: traits.systematic,
    },
    {
      dominant: 'ambitious',
      recessive: 'fulfilled',
      trait: traits.ambitious,
    },
  ]

  const checkPersonality = (score) => {
    if (score > 50) {
      return 'dominant'
    } else if (score < 50) {
      return 'recessive'
    } else {
      return 'balanced'
    }
  }

  const scoreResult = checkPersonality(testScore)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography textAlign={'start'}>Score details</Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          flexWrap: { md: 'nowrap', xs: 'wrap' },
          justifyContent: 'center',
        }}
      >
        {traitDetails.map((i, index) => {
          const selectedTab = currentTab === index
          return (
            <Box
              key={index}
              onClick={selectedTab ? () => {} : () => setCurrentTab(index)}
              sx={{
                width: { xs: 'fit-content', lg: '100%' },
                height: '48px',
                display: 'flex',
                px: 2,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: selectedTab ? 'primary.main' : 'transparent',
                color: selectedTab ? 'text.primary' : 'dark-text.main',
                borderRadius: '32px',
                border: selectedTab ? '1px solid' : '1px solid',
                borderColor: selectedTab ? 'primary.main' : 'grayscale.line-light',
                cursor: selectedTab ? '' : 'pointer',
              }}
            >
              <Typography sx={{ textTransform: 'capitalize' }}>{i.dominant}</Typography>
            </Box>
          )
        })}
      </Box>
      <Box sx={{ borderRadius: '4.5px', border: '1px solid #E5E5E5', bgcolor: 'white.main' }}>
        <Box sx={{ p: 2, display: 'flex', gap: '2' }}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
              <Typography variant="h4" fontWeight={700}>
                {traitDetails[currentTab].trait.avatar}
              </Typography>
              <Typography variant="h4" sx={{ textTransform: 'capitalize' }} fontWeight={700}>
                {`${testScore}%`} {traitDetails[currentTab].dominant}
              </Typography>
            </Box>
            <Typography>{traitDetails[currentTab].trait.description}</Typography>
          </Box>
        </Box>
        <Box sx={{ padding: '20px', borderTop: '1px solid #E5E5E5' }}>
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '14px',
            }}
          >
            <Typography
              color={scoreResult === 'dominant' ? 'dark-text.main' : 'primary.main'}
              textTransform={'capitalize'}
            >
              {`${100 - testScore}%`} {traitDetails[currentTab].recessive}
            </Typography>
            <Typography sx={{ position: 'absolute', width: '100%', textAlign: 'center' }}>
              vs
            </Typography>
            <Typography
              color={scoreResult === 'recessive' ? 'dark-text.main' : 'primary.main'}
              textTransform={'capitalize'}
            >
              {`${testScore}%`} {traitDetails[currentTab].dominant}
            </Typography>
          </Box>
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              width: '100%',
              height: '10px',
              borderRadius: '4.5px',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                flex: 1,
                height: '100%',
                backgroundColor: scoreResult === 'dominant' ? 'primary.light' : 'primary.main',
                backgroundColor: scoreResult === 'dominant' ? 'primary.light' : 'primary.main',
                borderRadius: '5px 0 0 5px',
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  backgroundColor: 'primary.main',
                  color: 'text.primary',
                }}
              >
                <CheckRoundedIcon sx={{ width: '20px', height: '20px' }} />
              </Box>
            </Box>
            <Box
              width={`${testScore}%`}
              sx={{
                height: '100%',
                backgroundColor: scoreResult === 'recessive' ? 'primary.light' : 'primary.main',
                backgroundColor: scoreResult === 'recessive' ? 'primary.light' : 'primary.main',
                borderRadius: '0 5px 5px 0',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ScoreDetailsTab
